import { Component } from '@angular/core';

@Component({
  selector: 'app-first-information-layer',
  standalone: false,
  templateUrl: './first-information-layer.component.html',
  styleUrl: './first-information-layer.component.scss'
})
export class FirstInformationLayerComponent {

}
